import api from './api';

export const login = ({ privyToken, deviceId }) =>
  api.post(
    '/auth/login',
    { deviceId },
    {
      headers: {
        'Content-Type': 'application/json',
        'x-privy-token': privyToken,
      },
    }
  );

export const guestLogin = ({ deviceId }) => api.post('/auth/guest-login', { deviceId });

export const renewRefreshToken = (refreshToken) => api.post('/auth/refresh-tokens', { refreshToken });

export const verifyAccessToken = (accessToken) => api.post('/auth/verify-tokens', { accessToken });

export const updateUserAttribution = (userId, attribution) => api.post(`/users/${userId}/attribution`, attribution);
